










import Vue from 'vue'
export default Vue.extend({

	methods: {

		async deleteMap() {
			const {success, error} = await this.$store.dispatch("deleteMap", this.$route.params.id);
			if(success) {
				this.$router.replace(`/`);
			} else {
				this.$store.commit("alert/addMessage", error)
			}
		},

		cancel() {
			this.$router.back();
		}
	}

})
